import { useState } from 'react'
import cloneDeep from 'lodash/cloneDeep'
import { getFundSubscriptionDataByCusip } from './FundDetailsDataSource.js'
import {
  getSubscriptionDataById,
  getSubscriptionsForUser,
  getStorageProfile,
} from '../../EmailSubscriptionCenter/Data/SubscriptionCenterDataSource.js'
import {
  updateFundData,
  updateSubscriptionData,
} from '../../EmailSubscriptionCenter/Landing/Helper/helper.js'
import {
  MODAL_TYPE_INSIGHTS,
  MODAL_TYPE_FUND,
} from '../../EmailSubscriptionCenter/Landing/Helper/constants.js'
import { getUrlParameter } from '../../../global/data/url.js'
import { isLoggedIntoSubscriptionCenter } from '../../../global/authentication/authentication-manager.js'
// import { updateFundSubscriptionBySubscriptionId } from '../../EmailSubscriptionCenter/Modal/Data/subscriptions.js'

export function useSubscriptionModelHook() {
  const cusip = getUrlParameter('cusip')

  const [subscriptionModel, setSubscriptionModel] = useState({
    showEmailSubscriptionModal: false,
    subscriptions: [],
    subscriptionCenterModalType: MODAL_TYPE_FUND,
    subscriptionProfile: null, //,
    // fundSubscription: null
  })

  const setShowEmailSubscriptionCenterModal = (flag, type) => {
    setSubscriptionModel((prevSubscriptionModel) => {
      return {
        ...prevSubscriptionModel,
        showEmailSubscriptionModal: flag,
        subscriptionCenterModalType: type,
      }
    })
  }

  const updateEmailsSubscriptionData = async (subscriptionModelDefault) => {
    let subscriptionProfile = null
    const fundSubscription = await getFundSubscriptionDataByCusip(cusip)
    const latestInsightId = '6bc1b266d5a146ad236481c964587e48'
    const insightSubscription = await getSubscriptionDataById(latestInsightId)

    if (isLoggedIntoSubscriptionCenter()) {
      subscriptionProfile = await getSubscriptionsForUser()
      subscriptionProfile.value = {
        ...getStorageProfile(),
        ...subscriptionProfile.value,
      }
      updateFundData([fundSubscription], subscriptionProfile.value)
      updateSubscriptionData(subscriptionProfile.value, {
        subscriptions: [insightSubscription],
      })
    } else {
      if (fundSubscription) {
        //select the first item in literature list (fact sheet)
        fundSubscription.activeLiterature = fundSubscription.literature
        if (
          fundSubscription.activeLiterature &&
          fundSubscription.activeLiterature.length > 0
        ) {
          fundSubscription.activeLiterature[0].selected = true
        }
      }
    }

    //fundSubscription (including literature) is reset here
    const _subscriptionModel = subscriptionModelDefault
      ? subscriptionModelDefault
      : { ...subscriptionModel }
    _subscriptionModel.fundSubscription = fundSubscription
    _subscriptionModel.subscriptionProfile = subscriptionProfile
    _subscriptionModel.subscriptions = [insightSubscription]

    setSubscriptionModel(_subscriptionModel)
  }

  const handleCloseModalClick = () => {
    const _subscriptionModel = { ...subscriptionModel }
    _subscriptionModel.showEmailSubscriptionModal = false
    // setSubscriptionModel(_subscriptionModel)
    updateEmailsSubscriptionData(_subscriptionModel)
  }

  // // FROM Insights.jsx
  // let doc, _subscriptions
  // if (subscriptionModel.subscriptions) {
  //   _subscriptions = [...subscriptionModel.subscriptions]
  //   doc = _subscriptions[0]
  // }

  // const handleSubscribeClicked = async (event) => {
  //   event.persist()

  //   if (isLoggedIntoSubscriptionCenter()) {
  //     doc.selected = event.currentTarget.dataset.unsubscribe !== 'true'
  //     doc.checked = doc.selected
  //     updateFundSubscriptionBySubscriptionId(
  //       subscriptionModel.subscriptionProfile,
  //       doc.id,
  //       doc.selected
  //     )
  //     setSubscriptions(_subscriptions)
  //     // setShowInsightsSuccessMessage(doc.selected)
  //   } else {
  //     doc.selected = true
  //     doc.checked = doc.selected
  //     setShowEmailSubscriptionCenterModal(true, MODAL_TYPE_INSIGHTS)
  //   }

  //   return null
  // }

  // const isSubscribed = () => {
  //   return doc && doc.checked && isLoggedIntoSubscriptionCenter()
  // }

  const setFundSubscription = (fundSubscription) => {
    setSubscriptionModel((prevSubscriptionModel) => {
      return {
        ...prevSubscriptionModel,
        fundSubscription: cloneDeep(fundSubscription),
      }
    })
  }

  const setSubscriptions = (subscriptions) => {
    const _subscriptionModel = { ...subscriptionModel }
    _subscriptionModel.subscriptions = subscriptions
    setSubscriptionModel(_subscriptionModel)
  }

  const getSubscriptions = () => {
    return subscriptionModel.subscriptionCenterModalType === MODAL_TYPE_INSIGHTS
      ? [...subscriptionModel.subscriptions]
      : []
  }

  const getFundSubscriptions = () => {
    return subscriptionModel.subscriptionCenterModalType === MODAL_TYPE_FUND &&
      subscriptionModel.fundSubscription
      ? [...subscriptionModel.fundSubscription.activeLiterature]
      : []
  }

  //like getFundSubscriptions, but for when MODAL_TYPE_FUND === 'fund' only
  const getFundSubscriptionsActiveLiterature = () => {
    return subscriptionModel?.fundSubscription?.activeLiterature
      ? [...subscriptionModel.fundSubscription.activeLiterature]
      : []
  }

  const getModalName = () => {
    return subscriptionModel.subscriptionCenterModalType === MODAL_TYPE_FUND &&
      subscriptionModel.fundSubscription
      ? subscriptionModel.fundSubscription.name
      : null
  }

  return [
    subscriptionModel,
    getFundSubscriptions,
    setFundSubscription,
    setShowEmailSubscriptionCenterModal,
    setSubscriptions,
    handleCloseModalClick,
    getSubscriptions,
    getModalName,
    updateEmailsSubscriptionData,
    getFundSubscriptionsActiveLiterature,
    // isLoggedIntoSubscriptionCenter,
    // handleSubscribeClicked,
    // isSubscribed
  ]
}
